import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./vuex/store";
import axios from "axios";
import Cookies from "js-cookie";
import "bootstrap";

import * as VueGoogleMaps from "vue2-google-maps";
import "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import "bootstrap-vue/dist/bootstrap-vue.css";

import Permissions from "./mixins/Permissions";
Vue.mixin(Permissions);

window.axios = require("axios");
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.prototype.$axios = axios;

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faSmile,
    faFrown,
    faMeh,
    faEdit,
    faTrash,
    faUserPlus,
    faKey,
    faSpinner,
    faCrosshairs,
    faSync,
    faMap,
    faMapMarked,
    faMapMarkedAlt,
    faEye,
    faEyeSlash,
    faCalculator,
    faCheck,
    faTimes,
    faMinusCircle,
    faThumbsUp,
    faExclamationTriangle,
    faLocationArrow,
    faChartBar, faFileExport,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import BootstrapVue, {
    NavbarPlugin,
    ToastPlugin,
    BButton,
    FormPlugin,
    BFormInput,
    BFormGroup,
    IconsPlugin,
    BPopover
} from "bootstrap-vue";

Vue.use(ToastPlugin);
Vue.use(FormPlugin);
Vue.component("b-input", BFormInput);
Vue.component("b-button", BButton);
Vue.component("b-popover", BPopover);
Vue.component("b-form-group", BFormGroup);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSweetalert2);

import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import ApiService from "./common/api.service";

library.add(
    faSmile,
    faFrown,
    faMeh,
    faEdit,
    faSpinner,
    faTrash,
    faUserPlus,
    faKey,
    faCrosshairs,
    faSync,
    faMap,
    faMapMarked,
    faMapMarkedAlt,
    faEye,
    faEyeSlash,
    faCalculator,
    faCheck,
    faTimes,
    faMinusCircle,
    faThumbsUp,
    faExclamationTriangle,
    faLocationArrow,
    faChartBar,
    faFileExport
);
Vue.use(NavbarPlugin);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GMAP_KEY,
        libraries: "places" // necessary for places input
    }
});

ApiService.init();

const moment = require("moment");
require("moment/locale/sk");

Vue.use(require("vue-moment"), {
    moment
});

export const bus = new Vue();

new Vue({
    created() {
        let bearer = Cookies.get("access_token");

        if (bearer) {
            window.axios.defaults.headers.common["Authorization"] = bearer;
            // window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        }

        // const host = window.location.host;
        // const parts = host.split('.'); // https://medium.com/@apalshah/vue-js-how-to-handle-multiple-subdomains-on-a-single-app-cba9b1f916c4
        window.axios.defaults.headers.common["X-CITY"] = "senec"; //parts[0];

        if (this.$store.getters.isAuthenticated) {
            this.$store.dispatch("userRequest");
        }
    },

    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
